import { render } from "./SelectRegionListItem.vue?vue&type=template&id=d9600738"
import script from "./SelectRegionListItem.vue?vue&type=script&lang=js"
export * from "./SelectRegionListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__